import Promise from "bluebird";
import {combineEpics} from 'redux-observable';
import EntryDescription from "module/edesc/EntryDescription";
import {from, of} from 'rxjs';
import {distinctUntilChanged, filter, map, switchMap, take} from 'rxjs/operators';
import ViewStoreModule from "util/ViewStoreModule";
import {resetEntryDescModelsAction, setEntryDescFavEditModeAction, setEntryDescFavIDsAction} from "module/edesc/action/EntryDescActions";
import {appInitAction, noopAction} from "util/ReduxUtil";
import {serverErrorHandlerJQ} from 'module/ConfirmDialog/compat/JQueryErrorHandlers';

//epics

const initEpic = action$ => action$.pipe(
	filter(appInitAction.match),
	take(1),
	switchMap(() =>
		from(Promise.resolve(EntryDescription.fetchOnce())).pipe(
			map(data => resetEntryDescModelsAction(data)),
		),
	),
);

const favViewStoreKey = {view: 'EntryDesc', key: 'fav'};

const initFavEpic = action$ => action$.pipe(
	filter(appInitAction.match),
	take(1),
	switchMap(() =>
		Promise.all([
			ViewStoreModule.enqueueFetch(favViewStoreKey.view),
			EntryDescription.fetchOnce(),
		]).then(() => {
				const fromRemote = ViewStoreModule.entries.getOrAdd(favViewStoreKey).get('value') || [];
				const filteredExisting = fromRemote.filter(id => EntryDescription.collection.get(id));
				return setEntryDescFavIDsAction(filteredExisting);
			},
		),
	),
);

const saveFavEpic = (action$, state$) => state$.pipe(
	map(state => state.EntryDesc.fav),
	filter(state => !!state),
	distinctUntilChanged(),
	switchMap(() => action$.pipe(
			filter(setEntryDescFavEditModeAction.match),
			filter(({payload: {status, reset}}) => !status && !reset),
			take(1),
			switchMap(() => {
				const {fav} = state$.value.EntryDesc;
				const model = ViewStoreModule.entries.getOrAdd(favViewStoreKey);
				model.set({value: fav});
				model.save().fail(serverErrorHandlerJQ);
				return of(noopAction());
			}),
		),
	),
);

export const entryDescEpic = combineEpics(initEpic, initFavEpic, saveFavEpic);